module.exports = __webpack_public_path__ + "img/OddsGaloreLogoGrey.6b6ca0da.png";